module.exports = __webpack_public_path__ + "static/media/search-icon.37f90037.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GlobalMenu/search-icon.svg
// module id = 585
// module chunks = 0